import React from 'react'
import {
  MUTUAL_FUND,
  ETF_FUND,
  ETF_INDEX_FUND,
  FUTURE_SCHOLAR_529,
  VARIABLE_FUND,
  CLOSED_END_FUND,
  MODEL_PORTFOLIOS,
} from '../../Helpers/FundTypes'
import LegacyFundViewer from './LegacyFundViewer.jsx'
import MutualFundViewer from './MutualFundViewer.jsx'

export default function FundViewer({ productList, fund }) {
  return (
    <div className="Modal u-hidden" id="mutual-fund-viewer">
      <div className="Modal-window">
        <button
          id="mutual-fund-viewer-close"
          className="Modal-icon u-cursorPointer u-textColorLight u-marginTop2gu u-marginRight2gu"
        />
        <div className="Modal-content u-padding8gu">
          {productList &&
            productList.value &&
            productList.value.products &&
            (fund.fundGroup === MUTUAL_FUND ||
              fund.fundGroup === ETF_FUND ||
              fund.fundGroup === ETF_INDEX_FUND ||
              fund.fundGroup === MODEL_PORTFOLIOS) && (
              <MutualFundViewer
                productList={productList.value.products}
                fundHeader={fund.fundHeader}
                fundPath={fund.fundPath}
                fundName={fund.name}
                isEtf={fund.fundGroup === ETF_FUND}
                isEtfIndex={fund.fundGroup === ETF_INDEX_FUND}
                isModelPortfolios={fund.fundGroup === MODEL_PORTFOLIOS}
              />
            )}

          {productList &&
            productList.value &&
            productList.value.products &&
            (fund.fundGroup === FUTURE_SCHOLAR_529 ||
              fund.fundGroup === VARIABLE_FUND ||
              fund.fundGroup === CLOSED_END_FUND) && (
              <LegacyFundViewer
                productList={productList.value.products}
                fund={fund}
              />
            )}
        </div>
      </div>
    </div>
  )
}
